import React, {useEffect, useState} from "react";
import {
    Card,
    CardHeader,
    CardBody,
    Typography,
    Input, Button, Tooltip, DialogHeader, DialogBody, DialogFooter, Dialog,

} from "@material-tailwind/react";
import {useLocation, useNavigate} from "react-router-dom";
import axios from "axios";
import {ExclamationCircleIcon} from "@heroicons/react/20/solid";

export default function ChangePasswordForm() {
    const [token, setToken] = useState(""); // Token koji ćemo dobiti iz URL-a
    const [lozinka, setLozinka] = useState("");
    const [povtrdaLozinke, setPovtrdaLozinke] = useState("");
    const [errorPassword, setErrorPassword] = useState(false);
    const [changePasswordError, setChangePasswordError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [openEmailVerificationDialog, setOpenEmailVerificationDialog] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    // Funkcija za preuzimanje query parametara
    const getTokenFromURL = () => {
        const urlParams = new URLSearchParams(location.search);
        return urlParams.get('token');
    };

    useEffect(() => {
        const tokenFromURL = getTokenFromURL();
        if (tokenFromURL) {
            setToken(tokenFromURL);
        }
    }, [location]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (lozinka !== povtrdaLozinke) {
            setErrorPassword(true);
            setErrorMessage("Lozinke se ne poklapaju.");
            return;
        }

        const API_URL = process.env.REACT_APP_API_URL;

        try {
            const response = await axios.post(`${API_URL}/auth/change_password`, {
                token,
                newPassword: lozinka
            });
            if (response.status === 200) {
                setOpenEmailVerificationDialog(true);
                setTimeout(() => {
                    navigate("/login");
                }, 5500);
            }
        } catch (err) {
            setChangePasswordError(true);
            setErrorMessage("Došlo je do greške pri promeni lozinke.");
        }
    };

    const handleOpenEmailVerificationDialog = () => {
        setOpenEmailVerificationDialog(!openEmailVerificationDialog);
    };

    const TooltipConfirmPasswordError = () => {
        return (
            <div className="p-1">
                <p className="text-red-500 font-bold">{errorMessage}</p>
            </div>
        );
    };

    return (
        <>
            <Card className="w-full max-w-3xl mx-auto rounded-3xl overflow-hidden shadow-2xl">
                <CardHeader
                    color="gray"
                    floated={false}
                    style={{
                        backgroundImage:
                            'linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 3)), url("/images/login-page/naslovna2.JPEG")',
                        backgroundBlendMode: 'multiply',
                    }}
                    className="m-0 grid place-items-center rounded-b-none py-8 px-4 bg-contain bg-center text-center"
                >
                    <div className="mt-4 mb-4 rounded-full border-4 border-white/30 bg-white/20 p-3 text-white">
                        <img
                            src="/transparent logo solo.png"
                            alt="Logo"
                            className="h-20 w-20"
                        />
                    </div>
                    <Typography variant="h4" color="white" className="font-semibold">
                        Smart Service System
                    </Typography>
                    <Typography variant="h6" color="white" className="mt-1">
                        - Vaša energija, naša briga -
                    </Typography>
                </CardHeader>

                <CardBody className="bg-white px-6 py-4 rounded-2xl">
                    <div className="flow-root">
                        <div className="flex flex-col items-center justify-center w-full px-6 py-4 sm:px-8 sm:py-6">
                            <Typography variant="h4" color="blue-gray" className="text-center mb-4 font-semibold">
                                Promena lozinke
                            </Typography>

                            <form className="mt-6 mb-2 w-full sm:max-w-md" onSubmit={handleSubmit}>
                                <div className="mb-4 flex flex-col gap-6">
                                    <Input
                                        color="blue"
                                        type="password"
                                        size="lg"
                                        label="Nova lozinka"
                                        value={lozinka}
                                        onChange={(e) => setLozinka(e.target.value)}
                                        className="rounded-lg border-2"
                                    />

                                    <Input
                                        color="blue"
                                        type="password"
                                        size="lg"
                                        label="Potvrdi novu lozinku"
                                        value={povtrdaLozinke}
                                        onChange={(e) => setPovtrdaLozinke(e.target.value)}
                                        error={errorPassword}
                                        className="rounded-lg border-2"
                                        icon={
                                            errorPassword && (
                                                <Tooltip content={<TooltipConfirmPasswordError />} placement="top-end" size="sm" className="bg-gray-100 border-1 border-red-700">
                                                    <ExclamationCircleIcon className="text-red-500 h-5 w-5" />
                                                </Tooltip>
                                            )
                                        }
                                    />
                                </div>

                                {/* Error message */}
                                {changePasswordError && (
                                    <div className="flex items-center justify-center mt-4">
                                        <Typography className="text-red-500 mr-2">Ups! Došlo je do greške</Typography>
                                        <Tooltip content={<TooltipConfirmPasswordError />} placement="top-end" size="sm" className="bg-gray-100 border-1 border-red-700">
                                            <ExclamationCircleIcon className="text-red-500 h-5 w-5" />
                                        </Tooltip>
                                    </div>
                                )}

                                {/* Submit Button */}
                                <Button
                                    color="green"
                                    className="text-white font-semibold py-3 px-6 sm:py-4 sm:px-8 rounded-full shadow-lg bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-r hover:from-blue-600 hover:via-blue-700 hover:to-blue-800 transition-all duration-300 mt-12 sm:mt-16"
                                    fullWidth
                                    type="submit"
                                >
                                    Promeni lozinku
                                </Button>
                            </form>
                        </div>
                    </div>
                </CardBody>
            </Card>

            <Dialog open={openEmailVerificationDialog} handler={handleOpenEmailVerificationDialog}>
                <DialogHeader>Vaša lozinka je uspešno promenjena</DialogHeader>
                <DialogBody>
                    <p className="mt-2">Bićete preusmereni na stranicu za logovanje.</p>
                </DialogBody>
                <DialogFooter>
                    <Button
                        variant="gradient"
                        color="blue"
                        onClick={handleOpenEmailVerificationDialog}
                    >
                        U redu
                    </Button>
                </DialogFooter>
            </Dialog>
        </>
    );
}